// The engine as a React external store. One controller per page; components read it with
// useSyncExternalStore through useEngineState().
import { createContext, useContext, useSyncExternalStore } from 'react';
import type { EngineState, GameController } from '../engine/controller';

export const GameContext = createContext<GameController | null>(null);

export function useController(): GameController {
  const c = useContext(GameContext);
  if (!c) throw new Error('useController: no GameContext provider');
  return c;
}

export function useEngineState(): EngineState {
  const c = useController();
  return useSyncExternalStore(c.subscribe, c.getState, c.getState);
}
